import type { BookingAllowedStatus } from '@/widgets/Wizard/models/time-table/status';
import type { WizardOptions } from '@/widgets/Wizard/models/time-table/wizard-options';
import type { Account } from '@/widgets/Wizard/models/accounts';

export abstract class TimeTableGateway {
    public abstract getBookingStatus(account: Account): Promise<BookingAllowedStatus>;
    public abstract getWizardOptions(account: Account): Promise<WizardOptions | null>;
}
